import Header from './components/Header';
import HeroSection from './components/HeroSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-800">
      <Header />

      <main>
        <HeroSection />
        <UpdatesSection />
        <IndexSection />
        <FaqSection />
        <AppSection />
        <CommentsSection />
        <ContactSection />
        <MediaSection />
        <FeaturesSection />
        <AboutSection />
        <RankingSection />
        <CarouselSection />
        <CardsSection />
        <TopicsSection />
      </main>

      <Footer />
    </div>
  );
}